import Testimonials from "@/entities/Testimonials";
import testimonialsData from "@/data/testimonials.json";

const testimonials = testimonialsData as unknown as Testimonials[];

export default class TestimonialsService {
  public async getTestimonials(): Promise<Testimonials[]> {
    return testimonials;
  }
}
